import React from "react";
import NewOrExistingAuth from "../../../common/basic_auth/NewOrExistingAuth";
import OktaUrlAndAuth from "./pages/OktaUrlAndAuth";
import WizardSchedule from "../../../common/WizardSchedule";
import { alwaysTrue } from "../../../../utils/wizardCommonValidations";
import OktaAssetStart from "./pages/OktaAssetStart";
import {oktaCredentialsNotBeEmpty,configurationCheck} from "./oktaInputValidation"
import {userNamePasswordNotEmpty} from "../../assets_wizard_validations"
import ConfirmOktaImport from "./pages/ConfirmOktaImport";
import okta_img from "../../../../../icons/okta.png"
const wizard = {
  title: "Okta Asset Import",
  id: "JSM_ASSETS_OKTA_IMPORT",
  description: "Import Okta Configuration and data into Assets",
  category: "JSM_ASSET_IMPORT",
  icon: <img src={okta_img} width={60} height={30}/>,
  pages: [
    {
      id: "1",
      label: "Credentials",
      percentageComplete: 0,
      status: "visited",
      href: "#",
      content: <NewOrExistingAuth info="Credentials are required for create asset import configurations."/>,
      validate: userNamePasswordNotEmpty
    },  
    {
      id: "2",
      label: "Okta",
      percentageComplete: 0,
      status: "visited",
      href: "#",
      content:<OktaUrlAndAuth />,
      validate: oktaCredentialsNotBeEmpty
    },
    {
      id: "3",
      label: "Import Configuration",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <OktaAssetStart />,
      validate: configurationCheck,
    }, 
    {
      id: "4",
      label: "Schedule",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <WizardSchedule />,
      validate: alwaysTrue
    }, 
    {
      id: "5",
      label: "Summary",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <ConfirmOktaImport />,
      validate: alwaysTrue

    }
  ],
};
export default wizard;
